// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import * as firebase from 'firebase'
import { store } from './stores/UserStore'
import Alert from './components/dialogs/Alert'

// Ignore production tips
Vue.config.productionTip = false

// Register components
Vue.component( 'app-alert', Alert )

// Set the app theme's color scheme
Vue.use(Vuetify, {
  theme: {
    primary: '#008080',
    secondary: '#424242',
    accent: '#F08080',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warnings: '#FFC107',
    urgent: '#e6e600'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created() {
    firebase.initializeApp({
      apiKey: "AIzaSyDTja3ENDuNGkpbCfSRoyGVbSN8h3sYnGc",
      authDomain: "projectmgmt-66576.firebaseapp.com",
      databaseURL: "https://projectmgmt-66576.firebaseio.com",
      projectId: "projectmgmt-66576",
      storageBucket: "projectmgmt-66576.appspot.com"
    }),
    firebase.auth().onAuthStateChanged( ( user ) => {
      if ( user ) {
        this.$store.dispatch( 'autoSignIn', user )
      }
    }),
    this.$store.dispatch('loadIssues')
  }
})



// WEBPACK FOOTER //
// ./src/main.js